__turbopack_context__.v({
  "plenty-button": "PlentySection-module-scss-module__RcPLMG__plenty-button",
  "plenty-container": "PlentySection-module-scss-module__RcPLMG__plenty-container",
});
